// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__5+jT5","default":"Paginator_default__MovVl","active":"Paginator_active__xEGhH"};